import type { FC } from "react";

import type { AppConfigsTab } from "src/app/features/ApplicationConfigurations/types/AppConfigsTypes";
import { ApplicationConfigurationsPropertyTable } from "./ApplicationConfigurationsPropertyTable";

export interface ApplicationConfigurationsTabProps {
    appConfigsTab: AppConfigsTab;
}

export const ApplicationConfigurationsTab: FC<ApplicationConfigurationsTabProps> = ({ appConfigsTab }) => {
    return (appConfigsTab.configFields && <ApplicationConfigurationsPropertyTable appConfigsTab={appConfigsTab} />) || null;
};
